import React, { useState, useEffect, useCallback } from 'react';
import styles from '../../styles/AsignacionBecasStyles/AsignacionBecas.module.css';
import Sidebar, { useSidebar } from '../../components/Sidebar';
import HeaderGlobal from '../../components/HeaderGlobal';
import SearchFilters from './SearchFilters';
import SearchBar from './SearchBar';
import StudentTable from './StudentTable';
import StudentDetail from './StudentDetail';
import ModalLux from '../../components/ModalLux';
import LoaderOverlay from '../../components/LoaderOverlay';

function AsignacionBecasScreen() {
  const { isCollapsed } = useSidebar();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTermDebounced, setSearchTermDebounced] = useState('');
  const [selectedCampus, setSelectedCampus] = useState('');
  const [selectedCiclo, setSelectedCiclo] = useState('');
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [showDetail, setShowDetail] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSearch = () => {
    setSearchTermDebounced(searchTerm);
  };

  const handleStudentClick = (student) => {
    setSelectedStudent(student);
    setShowDetail(true);
  };

  const handleBackToList = () => {
    setShowDetail(false);
    setSelectedStudent(null);
  };


  // Debounce para el buscador
  useEffect(() => {
    const handler = setTimeout(() => {
      setSearchTermDebounced(searchTerm);
    }, 400); // 400ms debounce
    return () => clearTimeout(handler);
  }, [searchTerm]);

  // Recibe loading desde StudentTable
  const handleLoading = useCallback((value) => setLoading(value), []);

  // ============================================================
  // BLOQUEO TEMPORAL: Pantalla en construcción
  // Para habilitar la pantalla, eliminar o comentar este bloque
  // ============================================================
  const PANTALLA_BLOQUEADA = false;  // Habilitada para multi-beca

  if (PANTALLA_BLOQUEADA) {
    return (
      <div className={styles.mainContainer}>
        <div className={`${styles.layout} ${isCollapsed ? styles.sidebarCollapsedLayout : ''}`}>
          <div className={styles.sidebarColumn}>
            <Sidebar />
          </div>
          <div className={styles.contentColumn}>
            <main className={styles.mainContent}>
              <HeaderGlobal title="Asignación de Becas" />
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 'calc(100vh - 180px)',
                backgroundColor: '#f8f9fa',
                borderRadius: '12px',
                margin: '24px',
                padding: '48px',
                textAlign: 'center'
              }}>
                <div style={{
                  fontSize: '64px',
                  marginBottom: '24px'
                }}>
                  🚧
                </div>
                <h2 style={{
                  fontSize: '28px',
                  fontWeight: '600',
                  color: '#1a1a2e',
                  marginBottom: '12px'
                }}>
                  Módulo en Construcción
                </h2>
                <p style={{
                  fontSize: '16px',
                  color: '#666',
                  maxWidth: '400px',
                  lineHeight: '1.6'
                }}>
                  Esta funcionalidad está siendo desarrollada y estará disponible próximamente.
                </p>
                <p style={{
                  fontSize: '14px',
                  color: '#999',
                  marginTop: '24px'
                }}>
                  Gracias por su paciencia.
                </p>
              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
  // ============================================================
  // FIN BLOQUEO TEMPORAL
  // ============================================================

  return (
    <div className={styles.mainContainer}>
      <div className={`${styles.layout} ${isCollapsed ? styles.sidebarCollapsedLayout : ''}`}>
        <div className={styles.sidebarColumn}>
          <Sidebar />
        </div>
        <div className={styles.contentColumn}>
          <main className={styles.mainContent}>
            <HeaderGlobal title="Asignación de Becas" />
            <div className={styles.contentArea}>
              <div className={styles.contentWrapper} style={{ position: 'relative', minHeight: 'calc(100vh - 64px)', height: 'auto' }}>
                <LoaderOverlay visible={loading} label="Cargando estudiantes..." />
                <SearchFilters 
                  selectedCampus={selectedCampus}
                  setSelectedCampus={setSelectedCampus}
                  selectedCiclo={selectedCiclo}
                  setSelectedCiclo={setSelectedCiclo}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  onSearch={handleSearch}
                />
                <StudentTable 
                  onStudentClick={handleStudentClick}
                  selectedCampus={selectedCampus}
                  selectedCiclo={selectedCiclo}
                  searchTerm={searchTermDebounced}
                  onLoading={handleLoading}
                />
                <ModalLux open={showDetail} onClose={handleBackToList} title="Detalle del Estudiante">
                  <StudentDetail 
                    student={selectedStudent}
                    onBack={handleBackToList}
                    // searchFilters y props de búsqueda removidos para no mostrar filtros en el modal
                  />
                </ModalLux>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default AsignacionBecasScreen;
